import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type AppScope = { customer: string | null; session: string | null }

/** App state belongs to one customer and one authenticated storage generation. */
export const appScopeSlice = createSlice({
  name: 'appScope',
  initialState: { customer: null, session: null } as AppScope,
  reducers: {
    appScopeChanged: (_state, action: PayloadAction<AppScope>) =>
      action.payload,
    appSessionChanged: (_state, action: PayloadAction<string | null>) => ({
      customer: null,
      session: action.payload,
    }),
  },
})

export const { appScopeChanged, appSessionChanged } = appScopeSlice.actions
